
























import FilterRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/FilterRequest";
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import SearchRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/SearchRequest";
import IFilterModel from "@models/IFilterModel";
import EventBus from "@models/eventBus";
import PaginationResponse from "@/api/dataSource/api/Common/ResponseModels/PaginationResponse";
import PaginationRequest from "@/api/dataSource/api/Common/RequestModels/PaginationRequest";

@Component
export default class CustomTableComponent extends Vue {
  @Prop({ required: false, type: Object }) filter: IFilterModel;
  @Prop({ default: true }) pagination: boolean;
  @Prop({ default: false, type: Boolean }) noSaveFilter: boolean;
  @Prop({ default: false, type: Boolean }) noClearBtn: boolean;
  @Prop({ required: true }) getDataFunc: (
    req?: Object
  ) =>
    | Promise<PaginationResponse<Object>>
    | ((req?: Object) => Promise<Object[]>);
  @Prop() removeFunc: (id: number) => Promise<boolean>;
  @Prop({ required: true }) templateColumns: string;
  @Prop({ required: true }) columnNames: string[];
  @Prop({ default: 10, type: Number }) pageSize: number;
  @Inject("eventBus") eventBus: EventBus;
  entitiesCount = 0;
  request: FilterRequest = null;
  get page(): number {
    return this.request.Pagination.Skip / this.request.Pagination.Take + 1;
  }
  set page(v: number) {
    this.request.Pagination.Skip = (v - 1) * this.pageSize;
  }
  get hasActiveFilterSlot():boolean{
     return Boolean(this.$slots["filter"]); 
  }
  isLoading = false;
  items: any[] = [];
  constructor() {
    super();
  }
  async fetchData() {
    this.isLoading = true;
    const filter =
      this.filter == null || this.filter.toFilterRequest == null
        ? null
        : this.filter.toFilterRequest();
    // выкидываем пагинацию и сортировку, т.к. есть значения по умолчанию которые перебивают стандартные вещи.
    if (filter) {
      delete filter.Pagination;
      delete filter.Sort;
    }
    Object.assign(this.request, filter || {});

    
    
    const res = await this.getDataFunc(this.request);
    console.log('getDataFunc', res);
    if (this.noSaveFilter) this.saveFilter();
    console.log('pagination', this.pagination);
    console.log('(res as PaginationResponse<any>).Items', (res as PaginationResponse<any>).Items);
    
    if (this.pagination && (res as PaginationResponse<any>).Items) {
      this.items = (res as PaginationResponse<any>).Items;
      
      this.entitiesCount = (res as PaginationResponse<any>).Count;
    } else if (Array.isArray(res)) {
      this.items = res;
      this.entitiesCount = res.length;
    }
      this.$forceUpdate()
    this.isLoading = false;
  }
  async created() {
    this.request = new FilterRequest({
      Pagination: this.pagination
        ? new PaginationRequest({
            Skip: 0,
            Take: this.pageSize,
          })
        : null,
    });
    this.fetchData();
    this.restoreFilter();
    this.eventBus.deleteEntity.on(this.deleteHandler);
  }
  saveFilter() {
    var dataName = `filter-data-${this.$route.name}`;
    var data = JSON.stringify(this.request);
    localStorage.setItem(dataName, data);
  }
  restoreFilter() {
    if (this.filter == null) {
      return;
    }
    var dataName = `filter-data-${this.$route.name}`;
    var dataJson = localStorage.getItem(dataName);
    if (!dataJson) return;
    var data = JSON.parse(dataJson);
    Object.assign(this.filter, data);
  }
  beforeDestroy() {
    this.eventBus.deleteEntity.removeListener(this.deleteHandler);
  }
  async deleteHandler(data: { id: number }) {
    const res = await this.$dialog.confirm(
      `Вы действительно хотите удалить сущность с ИД: ${data.id}?`
    );  
    if (!res) return;
    this.isLoading = true;

    await this.removeFunc(data.id).then(res => {
      if(res) {    
      this.fetchData();
      }
    }).catch(error => {
      this.$notification.error(error)    
      this.isLoading = false;
    })
    // const serverRes = await this.removeFunc(data.id);    
    // if (serverRes) {
    //   await this.fetchData();
    // } else {
    //     this.isLoading = false;
    //   }
  }
  resetPagination() {
    if (this.pagination) this.page = 1;
  }
  onSearch(request: SearchRequest[]) {
    this.request.Search = request;
    this.resetPagination();
    this.fetchData();
  }
  onPaginationChange(p: { Page: number; CountOnPage: number }) {
    this.page = p.Page;
    this.fetchData();
  }
}
